/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/ListOrTable
 * @desc List or table of experimentWorkflows
 */

import { ExperimentWorkflowList } from 'labstep-web/components/ExperimentWorkflow/List';
import ExperimentWorkflowTableTimeline from 'labstep-web/components/ExperimentWorkflow/TableTimeline';
import { MasterIndexCenterListOrTableContainer as MasterIndexCenterListOrTable } from 'labstep-web/screens/Master/Index/Center/ListOrTable';
import type React from 'react';
import { actions } from './constants';
import type { ExperimentWorkflowListOrTableProps } from './types';

export const ExperimentWorkflowListOrTable: React.FC<
  ExperimentWorkflowListOrTableProps
> = ({ experimentWorkflows, isTemplate, ...rest }) => (
  <MasterIndexCenterListOrTable
    tableComponent={
      <ExperimentWorkflowTableTimeline
        showCollaborators
        experimentWorkflows={experimentWorkflows}
        actions={actions}
        isTemplate={isTemplate}
        {...rest}
      />
    }
    listComponent={
      <ExperimentWorkflowList
        actions={actions}
        experimentWorkflows={experimentWorkflows}
        createdBy
      />
    }
  />
);
